var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1210_4444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4165 2.33691H2.33317C2.02375 2.33691 1.72701 2.45983 1.50821 2.67862C1.28942 2.89742 1.1665 3.19416 1.1665 3.50358V11.6702C1.1665 11.9797 1.28942 12.2764 1.50821 12.4952C1.72701 12.714 2.02375 12.8369 2.33317 12.8369H10.4998C10.8093 12.8369 11.106 12.714 11.3248 12.4952C11.5436 12.2764 11.6665 11.9797 11.6665 11.6702V7.58691",
    stroke: "#27387D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7915 1.46107C11.0236 1.22901 11.3383 1.09863 11.6665 1.09863C11.9947 1.09863 12.3094 1.22901 12.5415 1.46107C12.7736 1.69313 12.9039 2.00788 12.9039 2.33607C12.9039 2.66426 12.7736 2.97901 12.5415 3.21107L6.99984 8.75274L4.6665 9.33607L5.24984 7.00274L10.7915 1.46107Z",
    stroke: "#27387D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1210_4444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.70c45dac552c1d49211d72bebfd49658.svg";
export { ForwardRef as ReactComponent };